import { AxiosResponse } from 'axios';

import { api } from 'tools/api-service';

import type {
	GetWidgetSnapshotsRequestParams,
	GetWidgetSnapshotsResponse,
} from './types';

export const getWidgetSnapshots = async ({
	widgetId,
	page = 1,
	pageSize = 20,
	resultHash,
	interactionsBaseUrl,
}: GetWidgetSnapshotsRequestParams): Promise<
	AxiosResponse<GetWidgetSnapshotsResponse>
> => {
	const url = interactionsBaseUrl
		? `${interactionsBaseUrl}/${widgetId}/snapshots`
		: `/cityzens/interactions/${widgetId}/snapshots`;

	const params: Record<string, string | number> = {
		page,
		pageSize,
	};
	if (resultHash) {
		params.resultHash = resultHash;
	}

	return api.get<GetWidgetSnapshotsResponse>(url, { params });
};
